import ReactDOM from "react-dom/client"

export const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
)
